import { render } from "./MessageComposer.vue?vue&type=template&id=08886320&scoped=true"
import script from "./MessageComposer.vue?vue&type=script&lang=js"
export * from "./MessageComposer.vue?vue&type=script&lang=js"

import "./MessageComposer.vue?vue&type=style&index=0&id=08886320&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08886320"]])

export default __exports__